import { Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface RemixBadgeProps {
  remixOf?: string;
  originalUsername?: string;
}

export function RemixBadge({ remixOf, originalUsername }: RemixBadgeProps) {
  const navigate = useNavigate();

  if (!remixOf) return null;

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full text-xs">
      <Sparkles className="h-3 w-3 text-primary" />
      <span className="text-muted-foreground">
        Remix of{" "}
        {originalUsername && (
          <span
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/prompt/${remixOf}`);
            }}
            className="text-primary font-medium cursor-pointer hover:underline"
          >
            @{originalUsername}'s prompt
          </span>
        )}
      </span>
    </div>
  );
}
